var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateOracle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.075 10.096H6.131V7.152a.566.566 0 0 0-1.131 0v3.51c0 .312.253.565.566.565h3.51a.566.566 0 1 0 0-1.13zm9.359 2.34h-3.51a.566.566 0 1 0 0 1.131h2.945v2.945a.566.566 0 0 0 1.13 0v-3.51a.565.565 0 0 0-.565-.566z",
    fill: "#F4FFFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.888a5.792 5.792 0 0 0-2.985-3.316 5.792 5.792 0 0 0-4.456-.235 5.866 5.866 0 0 0-2.173 1.368L5.18 10.25a.566.566 0 0 0 .774.824l2.714-2.55a4.728 4.728 0 0 1 1.769-1.12 4.704 4.704 0 0 1 5.997 2.862.566.566 0 1 0 1.067-.378zm1.347 2.727a.565.565 0 0 0-.8-.025l-2.714 2.55a4.668 4.668 0 0 1-3.335 1.39h-.001a4.669 4.669 0 0 1-3.322-1.376 4.727 4.727 0 0 1-1.108-1.756.566.566 0 1 0-1.066.377 5.865 5.865 0 0 0 1.374 2.179 5.792 5.792 0 0 0 4.122 1.707h.001a5.792 5.792 0 0 0 4.116-1.703l2.708-2.544a.565.565 0 0 0 .025-.8z",
    fill: "#F4FFFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24,
    y1: 0,
    x2: -0.598,
    y2: 0.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DE995"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateOracle);
export default __webpack_public_path__ + "static/media/updateOracle.980434e19646bdab713532b97bbdca95.svg";
export { ForwardRef as ReactComponent };